import { render, staticRenderFns } from "./DuePortfolioBySupplier.vue?vue&type=template&id=e16b5ff2&"
import script from "./DuePortfolioBySupplier.vue?vue&type=script&lang=js&"
export * from "./DuePortfolioBySupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports